const lightTheme = {
  background_color: "#F2F2F2",
  surface: "#FFFFFF",
  primary: "#14C9CB",
  primary_variant: "",
  secondary: "#0FBED8",
  secondary_variant: "#0F8FA3",
  error: "#EB5757",
  error_variant: "#9e0420",
  success: "#6FCF97",
  info: "#2F80ED",
  warning: "#F2C94C",
  on_background: "#000",
  on_surface: "#000",
  on_primary: "#FFFFFF",
  on_secondary: "#FFFFFF",
  on_error: "#FFFFFF",
  star_color: "#FF9F43",
  arrows_color: "#8D8D8D",
  border_color: "#0000001a",
  darken_border_color: "#00000033",
  borderBlur: "",
  button_disabled: "",
  hover: "rgb(250, 250, 250)",
};

const darkTheme = {
  background_color: "#151515",
  surface: "#303030",
  primary: "#48d2d2",
  primary_variant: "",
  secondary: "#2ac7de",
  secondary_variant: "#13a4bd",
  error: "#CF6679",
  error_variant: "#9e0420",
  success: "#6FCF97",
  info: "#2F80ED",
  warning: "#F2C94C",
  on_background: "#FFFFFF",
  on_surface: "#FFFFFF",
  on_primary: "#FFFFFF",
  on_secondary: "#FFFFFF",
  on_error: "#FFFFFF",
  star_color: "#FF9F43",
  arrows_color: "#8D8D8D",
  border_color: "#FFFFFF1a",
  darken_border_color: "#FFFFFF33",
  borderBlur: "",
  button_disabled: "",
  hover: "rgba(255,255,255,0.2)",
};

const theme = (mode) => (mode === "dark" ? darkTheme : lightTheme);

export default theme;


// const darkTheme = {
//   background_color: "#121212",
//   surface: "#000",
//   surface_1dp: "rgba(255,255,255,0.05)",
//   surface_2dp: "rgba(255,255,255,0.07)",
//   surface_4dp: "rgba(255,255,255,0.09)",
//   surface_12dp: "rgba(255,255,255,0.14)",
//   surface_24dp: "rgba(255,255,255,0.16)",
//   primary: "#a7a6e3",
//   primary_variant: "#4637ae",
//   secondary: "#8D82FD",
//   secondary_variant: "",
//   error: "#CF6679",
//   error_variant: "#ac4f60",
//   success: "#00ca72",
//   on_background: "#FFFFFF",
//   on_surface: "#FFFFFF",
//   on_primary: "#FFFFFF",
//   on_secondary: "#FFFFFF",
//   on_error: "#FFFFFF",
//   star_color: "#FF9F43",
//   arrows_color: "#8D8D8D",
//   ripple_bank_color: "#332b8b",
//   ripple_star_color: "#fa9435",
//   ripple_holding_menu_item_color: "rgba(46, 46, 46, 0.05)",
//   border_color: "#4d4d4d", //#4b4e69
//   darken_border_color: "#686868",
//   hover_background: "rgb(98, 139, 139)",
//   hover_button: "rgb(102, 100, 100)",
//   hover: "rgba(255, 255, 255, 0.1)",
//   table_background: "#000",

//   // ripple_company_menu_item_color:""
// };